import { Container, Paper } from '@mui/material'
import PropTypes from 'prop-types'
import BoxAppBackground from '../BoxAppBackground/BoxAppBackground'
import BoxContent from '../BoxContent/BoxContent'
import BoxAppBackgroundAnimation from '../BoxAppBackgroundAnimation/BoxAppBackgroundAnimation'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  boxLogin: {
    zIndex: '1',
    position: 'relative',
  },
}))

const BoxLogin = (props) => (
  <BoxAppBackground component="main" display="flex" alignItems="center" justifyContent="center">
    <Container className={useStyles().boxLogin} maxWidth="sm">
      <Paper elevation={1}>
        <BoxContent {...props} />
      </Paper>
    </Container>
    <BoxAppBackgroundAnimation />
  </BoxAppBackground>
)

BoxLogin.propTypes = {
  children: PropTypes.node,
}

export default BoxLogin
